import { ItemOrigin } from '../ItemEditor.types';

interface ComputeHasFormChangesParams {
    isCreatingNewItem: boolean;
    itemOrigin: ItemOrigin;
    hasPreparedDefaultTemplate: boolean;
    unsavedItemChanges: boolean;
}

/**
 * Copied items, and prepared-default items that went through the pre-dialog
 * (non-empty template), arrive already filled in. Resetting the form with
 * those values leaves it clean — which would disable Create (LAX-10249).
 * A plain New Item — including prepared-default with an empty template,
 * where the dialog was skipped — follows the unsaved-changes signal.
 */
export function computeHasFormChanges({
    isCreatingNewItem,
    itemOrigin,
    hasPreparedDefaultTemplate,
    unsavedItemChanges,
}: ComputeHasFormChangesParams): boolean {
    if (isCreatingNewItem && itemOrigin === ItemOrigin.COPIED) {
        return true;
    }
    if (isCreatingNewItem && itemOrigin === ItemOrigin.PREPARED_DEFAULT && hasPreparedDefaultTemplate) {
        return true;
    }
    return unsavedItemChanges;
}

export function computeIsSaveDisabled({
    isSaving,
    isPending,
    isItemEditorTab,
    hasFormChanges,
}: {
    isSaving: boolean;
    isPending: boolean;
    isItemEditorTab: boolean;
    hasFormChanges: boolean;
}): boolean {
    if (isSaving || isPending || !isItemEditorTab) {
        return true;
    }
    return !hasFormChanges;
}
